export const fetchPromPay = async (sessionId: string, payId: string) => {
	try {
		const formData = new FormData();

		formData.append('method', 'add_promise_pay');
		formData.append('promise_pay_id', payId);
		formData.append('session_id', sessionId);

		const API = import.meta.env.VITE_API_BASE_URL;
		const url = `${API}/carbon`;

		const response = await fetch(url, {
			method: 'POST',
			body: formData,
		});

		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`);
		}

		const data = await response.json();

		return data;
	} catch (error) {
		console.error('Fetch error:', error);
		throw error;
	}
};
